<template>
  <md-card style="height: 360px; width: 400px;  align-items: center;">
    <md-card-content>
      <div class="md-layout text-center">
        <div class="md-layout-item ">
          <h5 style="margin-top: 10px; padding: 0px">Welcome To</h5>
          <img style="width: auto;" src="@/assets/img/GlobeChekWelcome.png" />

          <md-field style="margin-top: 50px;">
            <label>Register User Type</label>
            <md-select v-model="registerType" style="font-weight:600; font-size: 1.2rem;">
              <md-option value="Patient">Register Patient</md-option>
              <md-option value="Doctor">Register Doctor</md-option>
            </md-select>
          </md-field>

          <div style="margin-top:15px">
            <p style="max-width: 300px; text-align: justify;">
              To continue, select your user type and complete each of the following sections.
            </p>
          </div>

          <div style="margin-top:15px">
            <md-button class="md-plain md-sm md-transparent" @click="$router.push('/')">Cancel</md-button>

            <md-button class="md-sm md-primary" style="margin-left: 25px;" @click.prevent="
              registerType === 'Doctor' ? showSwal('drreg-confirmation') : showSwal('ptreg-confirmation')
              ">
              Register
            </md-button>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import Swal from "sweetalert2"
export default {
  components: {},
  data() {
    return {
      registerType: "Patient",
      image: "./img/default-avatar.png" // "./img/faces/avatar.jpg"
    }
  },

  methods: {
    showSwal(type) {
      if (type === "drreg-confirmation") {
        this.$router.push("/")
        //this.toggleSidebar();
        Swal.fire({
          buttons: {
            cancel: true,
            confirm: true
          },
          showCancelButton: true,
          cancelButtonText: "Cancel",
          cancelButtonClass: "md-button md-default",
          reverseButtons: true,
          confirmButtonClass: "md-button md-primary",
          confirmButtonText: "Register",
          buttonsStyling: false,

          html: ` <div align="Left">
                  <div align="Center"><img src="../img/GlobeChek.png" width="150" height="auto"></div>
                  <h5 class="info-text">Welcome Doctor!</h5>
                  <h5>
                    To register with GlobeChek for referrals you must currently be qualified
                    as Ophthalmologist (MD) or equivalent, Optometrist (OD), or Osteopath (DO).
                    <br/><br/>
                    Please complete each of the following sections. Once you have submitted your completed application,
                    you will receive an email with your login credentials and/or additional instructions within 48 hours.
                    <br/><br/>
                    If you experience any problems registering, please contact us at
                    <a href="mailto:info@globechek.com">Info@GlobeChek.com</span>
                  </h5></div>`
        }).then(result => {
          if (result.value) {
            this.$router.push("/register-doctor")
          }
        })
      }
      if (type === "ptreg-confirmation") {
        this.$router.push("/")
        //this.toggleSidebar();
        Swal.fire({
          showCancelButton: true,
          cancelButtonClass: "md-button md-default",
          confirmButtonClass: "md-button md-primary",
          confirmButtonText: "Register",
          cancelButtonText: "Cancel",
          buttonsStyling: false,
          reverseButtons: true,
          html: ` <div align="Left">
                  <div align="Center"><img src="../img/GlobeChek.png" width="150" height="auto"></div>
                  <h4 style="margin-top: 10px; margin-bottom: 10px"><strong>Patient Registration</strong></h4>
                  <h5 class="info-text">Welcome to GlobeChek!</h5>
                  <h5>
                    By choosing to be screened by GlobeChek, you are consenting to the use of your
                    depersonalized information collected by the screening by both GlobeChek and third parties.
                    All personally identifying information (name, address, phone number, email address, photograph, etc.)
                    will be removed prior to use or dissemination to a third party. Depersonalized data will be analyzed
                    in aggregate form by both GlobeChek and third parties for the purpose of statistical analysis of eye
                    health across demographic populations and to understand the effectiveness of eye screening and treatment
                    over time. If you do not agree to the use of your depersonalized data, you are not authorized to use
                    GlobeChek products or services.
                  </h5></div>`
        }).then(result => {
          if (result.value) {
            this.$router.push("/register-patient")
          }
        })
      }
    }
  }
}
</script>
<style>
.container {
  justify-content: right;
}

.md-blk {
  color: darkgray;
  background-color: darkgray;
}
</style>
